import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { ReactSortable } from 'react-sortablejs';

import { NavigationLink, ChatComponent, MiniMenu } from "components";
import { sidebarNavLinks } from 'constants/sidebarLinks/sidebarLinks';
import { getUserCuratorInfo } from 'redux/users/actions';
import { setIsChatOpened } from "redux/chat/reducer";
import { useLocation } from 'react-router-dom';
import { useUserSettings } from 'hooks/useUserSettings';
import { useSelector } from 'react-redux';
import { selectShortcuts } from 'redux/shortcuts/selectors';

const Sidebar = React.memo(({
  sidebarOpen,
  setSidebarOpen
}) => {
  const location = useLocation()
  const dispatch = useAppDispatch();

  const sidebar = useRef(null);
  // const [reorderedLinks, setReorderedLinks] = useState([]);
  const { updateSettings } = useUserSettings()

  const setIsChatOpenedHandler = (payload) => {
    dispatch(setIsChatOpened(payload));
  }

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current) return;
      const links = sidebar.current.querySelector('.hs-accordion-group')
      if (window.innerWidth > 1024) {
        const footer = sidebar.current.querySelector('footer')

        if (!sidebar.current.contains(target) || links.contains(target) || footer.contains(target)) return;

        setSidebarOpen((old) => !old);
      } else {
        const burgerMenuBtnSm = document.getElementById("burgerMenuBtnSm")
        const burgerMenuBtnMaxSm = document.getElementById("burgerMenuBtnMaxSm")

        if (!sidebar.current.contains(target) || links.contains(target) || burgerMenuBtnSm.contains(target) || burgerMenuBtnMaxSm.contains(target)) return;
        setSidebarOpen((old) => !old);
      }
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  }, []);

  const { accessToken, currentSellerId, isChatOpened, settings } = useAppSelector(({ users, sellers, chat }) => ({
    accessToken: users.currentUser.data.accessToken,
    currentSellerId: sellers.currentSeller.info.data?.id,
    isChatOpened: chat.isChatOpened,
    settings: users.currentUser.settings
  }))
  const shortcuts = useSelector(selectShortcuts);

  const showItemLink = (name) => {
    return true;
  }

  useEffect(() => {
    if (accessToken) {
      dispatch(getUserCuratorInfo());
    }
  }, [accessToken])

  const isLinkActive = (pathname) => {
    return location.pathname.includes(pathname.replace(":id", currentSellerId));
  }
  const isMainPageLinkActive = currentSellerId && window.location.pathname.split("/").splice("2").join("") === currentSellerId.toString();

  const reorderedLinks = useMemo(() => {
    const savedOrder = settings.sortableNavElements

    if (savedOrder) {
      const orderedLinks = sidebarNavLinks
        .filter(item => showItemLink(item.name))
        .sort((a, b) => {
          return savedOrder.indexOf(a.name) - savedOrder.indexOf(b.name);
        });
      return orderedLinks;
    } else {
      return sidebarNavLinks.filter(item => showItemLink(item.name));
    }
  }, [settings]);

  const endDrag = (newList) => {
    if (JSON.stringify(reorderedLinks) !== JSON.stringify(newList)) {
      updateSettings({ sortableNavElements: newList.map((item) => item.name) }, true)
    }
  }

  return (
    <>
      <aside
        className={`
          transition-all duration-300 transform
          h-[100% - 20px] max-sm:max-h-[calc(100dvh-4.25rem-env(safe-area-inset-bottom,0px))] max-sm:overflow-y-auto max-sm:rounded-tr-lg fixed sm:inset-y-0 sm:start-0 z-60 bg-theme-bg
          ${sidebarOpen ? 'max-sm:block w-49.5' : 'max-sm:hidden sm:w-10.5'}
          max-sm:left-0 max-sm:bottom-[var(--mobile-bar-h)] lg:block lg:translate-x-0 lg:end-auto lg:bottom-0
          dark:bg-theme-bg lg:mt-10.5 maxh620:mt-8.5 sm:mt-8.5 text-theme-color dark:text-theme-color`}
        ref={sidebar}
      >
        <div className="relative flex flex-col h-full max-h-full justify-between max-sm:h-auto">
          <div className="flex-1 min-h-0 overflow-auto !scrollbar-none">
            <nav className="hs-accordion-group w-full flex flex-col flex-wrap" data-hs-accordion-always-open>
              {reorderedLinks?.length > 0 &&
                (<ul className="flex flex-col gap-y-1">
                  <ReactSortable
                    animation={150}
                    handle=".drag-handle"
                    dragClass='[&_a]:!border-none'
                    list={reorderedLinks}
                    setList={endDrag}
                    group="navigation"
                  >
                    {reorderedLinks
                      .map((item) => (
                        <NavigationLink
                          key={item.path}
                          onClick={window.innerWidth < 1024 && (() => {
                            sidebarOpen && setSidebarOpen(false)
                          })}
                          Icon={item.Icon}
                          name={item.name}
                          path={item.path.replace(":id", currentSellerId)}
                          currentSellerId={currentSellerId}
                          isActive={item.path !== '/' ? isLinkActive(item.path) : isMainPageLinkActive}
                          sidebarOpen={sidebarOpen}
                          shortcuts={shortcuts}
                        />
                      ))
                      }
                    </ReactSortable>
                </ul>)
              }
            </nav>
          </div>

          <footer className='lg:block md:hidden sm:hidden max-sm:hidden maxh620:hidden'>
            <MiniMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          </footer>
        </div>
      </aside>
      <ChatComponent
        chatOpened={isChatOpened}
        setChatOpened={setIsChatOpenedHandler}
      />
    </>
  );
});

export default Sidebar;